import { render, staticRenderFns } from "./DetailsCall.vue?vue&type=template&id=db2ffc96"
import script from "./DetailsCall.vue?vue&type=script&lang=js"
export * from "./DetailsCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerIos});
